import { ConfigPedido } from '../../configuracoes/app/pedido';

/** Status dos pedidos */
export interface PedidoStatus {
    id: number;
    nome: string;
}

export const pedidoNaoConfirmado: PedidoStatus = {id: 1, nome: 'Não Confirmado'};
export const pedidoConfirmado: PedidoStatus = {id: 2, nome: 'Confirmado'};
export const pedidoEmAnalise: PedidoStatus = {id: 3, nome: 'Em análise'};
export const pedidoAprovado: PedidoStatus = {id: 4, nome: 'Aprovado'};
export const pedidoReprovado: PedidoStatus = {id: 5, nome: 'Reprovado'};
export const pedidoCancelado: PedidoStatus = {id: 6, nome: 'Cancelado'};
export const pedidoFaturado: PedidoStatus = {id: 7, nome: 'Faturado'};
export const pedidoProducao: PedidoStatus = {id: 8, nome: 'Produção'};
export const pedidoNaoLiberado: PedidoStatus = {id: 9, nome: 'Não Liberado'};
export const pedidoFaturadoParcial: PedidoStatus = {id: 10, nome: 'Faturado Parcial'};
export const pedidoConfirmandoERP: PedidoStatus = {id: 11, nome: 'Confirmando ERP'};
export const pedidoAbertoERP: PedidoStatus = {id: 12, nome: 'Aberto ERP'};
export const pedidoRevisao: PedidoStatus = {id: 13, nome: 'Revisão'};
export const pedidoEmAnaliseCliente: PedidoStatus = {id: 14, nome: 'Em Analise Cliente'};
export const pedidoStatusOutro: PedidoStatus = {id: 99, nome: 'Outro'};

export const pedidoStatus: PedidoStatus[] = [
    pedidoNaoConfirmado,
    pedidoNaoLiberado,
    pedidoConfirmado,
    pedidoConfirmandoERP,
    pedidoAbertoERP,
    pedidoRevisao,
    pedidoEmAnalise,
    pedidoAprovado,
    pedidoReprovado,
    pedidoProducao,
    pedidoFaturado,
    pedidoFaturadoParcial,
    pedidoCancelado,
    pedidoEmAnaliseCliente
    // pedidoStatusOutro
];


/** Array de statuses dos pedidos considerados em metas e resultados. Remove status que não devem ser considerados, por exemplo: Não Confirmado, Reprovado e Cancelado */
export const pedidoStatusMetas: PedidoStatus[] = [
    pedidoConfirmado,
    pedidoConfirmandoERP,
    pedidoAbertoERP,
    pedidoEmAnalise,
    pedidoAprovado,
    pedidoProducao,
    pedidoFaturado,
    pedidoFaturadoParcial,
];

/** Obtem o status do pedido através do valor informado */
export function getStatus(status: number): PedidoStatus {
    return pedidoStatus.find(statusFilter => statusFilter.id === status);
}

/** Obtem os statuses dos pedidos para inserção */
export function getStatusesInsert(configPedido: ConfigPedido): PedidoStatus[] {
    const status: PedidoStatus[] = [];
    configPedido.status?.forEach(configStatus => {
        if (configStatus.insertPedido) {
            const statusPedido = getStatus(configStatus.status);
            status.push(statusPedido);
        }
    });

    return status;
}


/** Obtem os statuses dos pedidos para edição */
export function getStatusesEdit(configPedido: ConfigPedido): PedidoStatus[] {
    const status: PedidoStatus[] = [];
    configPedido.status?.forEach(configStatus => {
        if (configStatus.editPedido) {
            const statusPedido = getStatus(configStatus.status);
            status.push(statusPedido);
        }
    });

    return status;
}

/** Function auxiliar para obter os statuses dos pedidos para serem utilizados como filtros em consultas de pedidos */
export function getStatusesConsultaPedidos(incluirNaoConfirmado = false, incluirNaoLiberado = false, incluirCancelado = false, incluirRevisao = false, incluirEmAnaliseCliente = false) {
    const statuses: PedidoStatus[] = [];
    // Não Confirmado
    if (incluirNaoConfirmado) {
        statuses.push(pedidoNaoConfirmado);
    }
    // Não Liberado
    if (incluirNaoLiberado) {
        statuses.push(pedidoNaoLiberado);
    }
    // Confirmado
    statuses.push(pedidoConfirmado);
    // Confirmando ERP
    statuses.push(pedidoConfirmandoERP);
    // Aberto ERP
    statuses.push(pedidoAbertoERP);
    // Em Análise
    statuses.push(pedidoEmAnalise);
    // Aprovado
    statuses.push(pedidoAprovado);
    // Reprovado
    statuses.push(pedidoReprovado);
    // Produção
    statuses.push(pedidoProducao);
    // Faturado
    statuses.push(pedidoFaturado);
    // Faturado Parcial
    statuses.push(pedidoFaturadoParcial);
    // Cancelado
    if (incluirCancelado) {
        statuses.push(pedidoCancelado);
    }
    // Revisão
    if (incluirRevisao) {
        statuses.push(pedidoRevisao);
    }
    // Em Análise Cliente
    if (incluirEmAnaliseCliente) {
        statuses.push(pedidoEmAnaliseCliente);
    }

    return statuses;
}


/** Verifica se o status do pedido é igual a NaoConfirmado */
export function isPedidoNaoConfirmado(status: number): boolean {
    return status === pedidoNaoConfirmado.id;
}

/** Verifica se o status do pedido é igual a Confirmado */
export function isPedidoConfirmado(status: number): boolean {
    return status === pedidoConfirmado.id;
}

/** Verifica se o status do pedido é igual a EmAnalise */
export function isPedidoEmAnalise(status: number): boolean {
    return status === pedidoEmAnalise.id;
}

/** Verifica se o status do pedido é igual a Aprovado */
export function isPedidoAprovado(status: number): boolean {
    return status === pedidoAprovado.id;
}

/** Verifica se o status do pedido é igual a Reprovado */
export function isPedidoReprovado(status: number): boolean {
    return status === pedidoReprovado.id;
}

/** Verifica se o status do pedido é igual a Cancelado */
export function isPedidoCancelado(status: number): boolean {
    return status === pedidoCancelado.id;
}

/** Verifica se o status do pedido é igual a Faturado */
export function isPedidoFaturado(status: number): boolean {
    return status === pedidoFaturado.id;
}

/** Verifica se o status do pedido é igual a Producao */
export function isPedidoProducao(status: number): boolean {
    return status === pedidoProducao.id;
}

/** Verifica se o status do pedido é igual a NaoLiberado */
export function isPedidoNaoLiberado(status: number): boolean {
    return status === pedidoNaoLiberado.id;
}

/** Verifica se o status do pedido é igual a Faturado Parcial */
export function isPedidoFaturadoParcial(status: number): boolean {
    return status === pedidoFaturadoParcial.id;
}

/** Verifica se o status do pedido é igual a Confirmando ERP */
export function isPedidoConfirmandoERP(status: number): boolean {
    return status === pedidoConfirmandoERP.id;
}


/** Verifica se o status do pedido é igual a Aberto ERP */
export function isPedidoAbertoERP(status: number): boolean {
    return status === pedidoAbertoERP.id;
}

/** Verifica se o status do pedido é igual a Revisão */
export function isPedidoRevisao(status: number): boolean {
    return status === pedidoRevisao.id;
}

/** Verifica se o status do pedido é igual a Em Análise Cliente */
export function isPedidoEmAnaliseCliente(status: number): boolean {
    return status === pedidoEmAnaliseCliente.id;
}


/** Verifica se o status do pedido é igual a Outro */
export function isPedidoStatusOutro(status: number): boolean {
    return status === pedidoStatusOutro.id;
}
